import React, { useEffect, useState } from "react";
import { deleteChapterSvc } from "./chapterSvc";
import { toast, ToastContainer } from "react-toastify";

const ChapterTable = (props) => {
    console.log('props:', props)
    const [chapterId, setChapterId] = useState(0);
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(0);

    const handleRowClick = (pChapterId, pChapterCode, pChapterName, pPeriods) => {
        // console.log("handleRowClick called, chapterId", pChapterId);
        setChapterId(pChapterId);
        props.rowClick(pChapterId, pChapterCode, pChapterName, pPeriods);
    }

    const deleteChapterResponse = (data) => {
        console.log("deleteChapterResponse called, data", data);
        let obj = data;
        if (obj.status === 'Success') {
            toast.success(obj.message);
            props.getChapterList(props.sybSubId);
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader('none');
        setOpacity(1);
    }

    return (
        <div>
            <table className="tableLayout1" id='customTable'>
                <thead>
                    <tr>
                        <th width="50">S.No.</th>
                        <th width="100">Chapter</th>
                        <th width="150">Name</th>
                        <th width="50">Periods</th>
                        <th width="80">Action</th>
                    </tr>
                </thead>
            </table>
            <div className="tableDivMedium">
                <table id="mainTable" className='tableLayout'>
                    <tbody id="chapterTableBody">
                        {props.lstChapters && props.lstChapters.length !== 0 && props.lstChapters.map((chapter, index) => (
                            <tr
                                key={chapter.chapterId}
                                id={chapter.chapterId}
                                className={chapter.chapterId === chapterId ? "selected" : ""}
                                onClick={() => handleRowClick(chapter.chapterId, chapter.chapterCode, chapter.chapterName, chapter.periods)}
                            >
                                <td width="50" className="text-left">{index + 1}</td>
                                <td width="100" className="text-left">{chapter.chapterCode}</td>
                                <td width="150" className="text-left">{chapter.chapterName}</td>
                                <td width="50" className="text-right">{chapter.periods}</td>
                                <td width="80" className="text-center"
                                    onClick={(e) => {
                                        console.log('parent clicked')
                                        window.confirm("Are you sure to delete the chapter?");
                                        deleteChapterSvc(chapter.chapterId, deleteChapterResponse);
                                    }}>
                                    <span className="glyphicon glyphicon-remove" title='Delete'
                                        onClick={(e) => {
                                            console.log('child clicked')
                                            e.stopPropagation();
                                            window.confirm("Are you sure to delete the chapter?");
                                            deleteChapterSvc(chapter.chapterId, deleteChapterResponse);
                                        }}>
                                    </span></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>

    );
}

export default ChapterTable;